// extracted by mini-css-extract-plugin
export default {"wrapper":"language_wrapper__hvQUT","note":"language_note__Q3MEs"};